<template>
  <footer class="page-footer">
    <div class="footer-bottom container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-5 copyright-container">
            &copy; Paul Smith Ltd
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
export default {
  name: "Footer"
};
</script>